;(function ( $ ) {

    /**
     *  toggleListingCheckboxes
     *  toggle all checkboxes in listing table on or off
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'toggleListingCheckboxes';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            var $tbody = $(this.element).parents('.listing-table').find('tbody');
            this.$checkbox = $(this.element).find('input[type="checkbox"]');
            this.$checkbox.on('change', function() {
                var checked = $(this).filter(':checked').length;
                if (checked) {
                    $tbody.find('input[type="checkbox"]').prop('checked', true);
                } else {
                    $tbody.find('input[type="checkbox"]').prop('checked', false);
                }
                $tbody.find('input[type="checkbox"]').trigger('change');
            });
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
